export class IAttributes {

    attributeId: string;
    attributeType: string;
    attributeName: string;
    attributeDesc: string;
    isActive: boolean;
    createdBy: string;
    createdOn: Date;
    modifiedBy: string;
    modifiedOn: Date;
    dbOperations: string;
    claimCode: string;
    // ascInsFlag : boolean;
    encounterId: string;
    selected: boolean;
    locations?: string;
}
export class IRace {
    raceId: number;
    race: string;
    parentId: number;
    loincCode: string;
    isActive: boolean;
    createdBy: string;
    createdOn: Date;
    modifiedBy: string;
    modifiedOn: Date;

}

export class IAllergySnomed {
    conceptCode: string;
    conceptName: string;
    preferredConceptName: string;
}

